//@flow
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import WarningIcon from "@material-ui/icons/Warning";

import { withStyles } from "@material-ui/core";
import type { DictionaryType } from "../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../types/GeneralTypes";
import { buttonStyles } from "../styles/buttonStyles";

import { CancelButton } from "imagus-components";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  warningIcon: {
    marginRight: "10px",
    verticalAlign: "middle"
  },
  content: {
    fontWeight: 500,
    fontSize: "1.125rem"
  },
  highlight: {
    color: theme.palette.secondary.main
  }
});

type CustomConfirmCancelDialogClassesType = {
  ...ButtonStylesClassesType,
  warningIcon: DictionaryType,
  content: DictionaryType,
  highlight: DictionaryType
};

type CustomConfirmCancelDialogPropsType = {
  classes: ConfirmCancelDialogClassesType,
  open: boolean,
  handleModalStatus: Function,
  deleteFunction: Function,
  deleteWord?: string,
  title?: string,
  itemName: string,
  extraWord?: string
};

class CustomConfirmCancelDialog extends Component<
  CustomConfirmCancelDialogPropsType,
  *
> {
  handleClickOpen = () => {
    this.props.handleModalStatus(true);
  };

  handleClose = () => {
    this.props.handleModalStatus(false);
  };

  confirmRemove = (): * => {
    this.props.deleteFunction();
    this.handleClose();
  };

  render(): * {
    const classes = this.props.classes;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-delete"
        aria-describedby="alert-dialog-delete-item"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          <WarningIcon color="secondary" className={classes.warningIcon} />
          {this.props.title ? this.props.title : "Confirm your Action"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-content"
            className={classes.content}
          >
            Are you sure you want to{" "}
            <span className={classes.highlight}>
              {this.props.deleteWord ? this.props.deleteWord : "Delete"}
            </span>{" "}
            <b>{this.props.itemName}</b>{" "}
            {this.props.extraWord ? this.props.extraWord : "from the list"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton noMargin onClick={this.handleClose} />
          <Button
            type="button"
            variant="contained"
            onClick={this.confirmRemove}
            color="secondary"
            id="deleteBtn"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(CustomConfirmCancelDialog);
